
import {getConfig,updateConfig,getConfigs } from '@/services/endpoints/configs'

export default {
    async updateConfig({commit},payload) {
        try {
            let res = await updateConfig(payload.id, payload.payload);
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },
    async getConfig({ commit }, id) {
        try {
            let res = await getConfig(id);
            if(res) {
                commit('SET_CONFIG_TO_EDIT', res.data[0])
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async getConfigs({ commit }, id) {
        try {
            let res = await getConfigs();
            if(res) {
                commit('SET_CONFIG_TO_EDIT', res.data)
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
}